import { forwardRef, type ReactNode } from "react";

type RadioOptionProps = Omit<React.ComponentProps<"input">, "type" | "children"> & {
  /** The visible option content — the consumer owns the visual (dot, label, …). */
  children: ReactNode;
  /** Class for the wrapping <label> (the visible control surface). */
  className?: string;
  style?: React.CSSProperties;
};

/**
 * A single radio inside a `role="radiogroup"` container: the native input stays
 * in the DOM for semantics and keyboard/AT behaviour, visually hidden by the
 * consumer's CSS (`… input { position:absolute; opacity:0 }`), with the visible
 * control rendered as `children`. Same division of labour as `Checkbox`, minus
 * the fixed `.af-check` skin — surfaces bring their own (e.g. `.at-option`).
 */
export const RadioOption = forwardRef<HTMLInputElement, RadioOptionProps>(
  function RadioOption({ children, className, style, ...props }, ref) {
    return (
      <label className={className} style={style}>
        <input ref={ref} type="radio" {...props} />
        {children}
      </label>
    );
  },
);
